export default __webpack_public_path__ + "static/media/people_desktop_banner.67befbcb.png";